import ExternalLink from 'components/UI/ExternalLink'
import React, { ReactElement } from 'react'
import getEnglishStrings from 'utils/getEnglishStrings'

export default function CTA({ data }: { data: Queries.DirectusData_component_cta }): ReactElement {
  const { url } = data
  const strings = getEnglishStrings(data.strings)
  return (
    <ExternalLink sxx={{ variant: 'buttons.neonGreen', width: 'fit-content' }} href={url ?? ''}>
      {strings?.text}
    </ExternalLink>
  )
}
